<eazly-header dashboard="Dashboard"></eazly-header>
<dashboard [dataToDisplay]="appeazsToDisplay"></dashboard>
